import { YodaColors } from 'yoda-ui/yodaTheme';

export const Collapse = {
  width: '100%',
  borderTop: `1px solid ${YodaColors.gray2}`,
};
